// React Component
import React from 'react'

interface Options {
    value: string
    label: string

}

interface SelectProps {
    onChange(event: React.SyntheticEvent): any
    placeholder: string
    selectClass?: string
    selectName: string
    selectOptions: Array<Options>
    defaultValue?: string
    value?: string  // Prop value pour composant contrôlé
}

const SelectForm = (props: SelectProps) => {
    const { selectClass, onChange, placeholder, selectName, selectOptions, defaultValue, value } = props

    // Utiliser value si fourni (composant contrôlé), sinon defaultValue (composant non-contrôlé)
    const selectValue = value !== undefined ? value : (defaultValue || "")

    return (
        <select 
            className={`form-select form-select-lg text-theme ${selectClass}`} 
            value={selectValue} 
            name={selectName} 
            onChange={(event) => onChange(event)} 
            style={{ fontSize: "1rem", height: 58, cursor: "pointer" }}
        >
            <option value="" disabled>{placeholder}</option>
            {selectOptions.map((option) => (
                <option value={option.value} key={option.value}>{option.label}</option>
            ))}
        </select>
    )
}

export default SelectForm